import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, Heart, Gem, Sparkles, ArrowRight, Check } from 'lucide-react';
import { LOGO, IMAGES, ABOUT, BRAND } from '../mock';

const About = () => {
  return (
    <div className="pt-28 pb-24">
      <section className="relative py-16 overflow-hidden">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 h-[400px] w-[400px] rounded-full bg-[#d6197d]/12 blur-[120px] glow-pulse" />
        <div className="relative max-w-3xl mx-auto px-5 text-center">
          <img src={LOGO} alt="Prestige Elements" className="h-32 w-32 mx-auto rounded-full ring-1 ring-[#d4af37]/40 floaty" />
          <p className="font-jost text-xs tracking-[0.4em] text-[#ff4da6] uppercase mt-6 mb-3">Established 2019</p>
          <h1 className="font-cinzel text-4xl md:text-6xl text-gold-gradient">Prestige Elements</h1>
          <div className="gold-divider my-6" />
          <p className="font-cormorant text-2xl text-[#f5ecd9]/80 italic">{ABOUT.heading}</p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-5 py-8">
        <div className="space-y-6 font-jost text-[#f5ecd9]/70 leading-relaxed text-lg">
          <p>{ABOUT.body}</p>
          <p>Prestige Elements connects <span className="text-[#f0d582]">Beauty + Nature + Energy + Spiritual Wellness</span> into one house. From all-natural body oils, skincare, and hair care to healing crystals, herbs, and spiritual services — every element is designed to help you <em className="text-[#ff4da6] not-italic">{BRAND.motto}</em></p>
        </div>

        <div className="card-glass rounded-2xl p-8 mt-10">
          <h3 className="font-cinzel text-xl text-[#f0d582] mb-5">Areas We Cover</h3>
          <div className="grid sm:grid-cols-2 gap-3">
            {ABOUT.areas.map((a) => (<div key={a} className="flex items-center gap-3 font-jost text-[#f5ecd9]/75"><Check className="h-4 w-4 text-[#ff4da6] flex-shrink-0" /> {a}</div>))}
          </div>
          <p className="font-jost text-sm text-[#f5ecd9]/50 mt-6 border-t border-white/5 pt-4">{ABOUT.note}</p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-5 py-12">
        <div className="grid md:grid-cols-3 gap-7">
          {[
            { icon: Leaf, t: 'Rooted in Nature', d: 'Pure plant extracts, essential oils and real flower essence in every formula.' },
            { icon: Gem, t: 'Charged with Intention', d: 'Healing crystals and herbs aligned to your chakras for balance and clarity.' },
            { icon: Heart, t: 'Spiritual Wellness', d: 'Readings, spiritual baths, chakra work and guided yoga with our practitioners.' },
          ].map((v) => (
            <div key={v.t} className="card-glass rounded-2xl p-8 text-center hover-lift"><div className="h-14 w-14 mx-auto rounded-full border border-[#d4af37]/30 flex items-center justify-center mb-4"><v.icon className="h-6 w-6 text-[#f0d582]" /></div><h3 className="font-cinzel text-lg text-[#f5ecd9] mb-2">{v.t}</h3><p className="font-jost text-sm text-[#f5ecd9]/60">{v.d}</p></div>
          ))}
        </div>
      </section>

      <section className="relative max-w-6xl mx-auto px-5 py-12">
        <div className="relative rounded-3xl overflow-hidden">
          <img src={IMAGES.spa2} alt="Wellness ritual" className="w-full h-72 md:h-96 object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0a0708] to-transparent flex items-center">
            <div className="px-8 md:px-14 max-w-lg">
              <Sparkles className="h-8 w-8 text-[#f0d582] mb-4" />
              <h2 className="font-cinzel text-3xl md:text-4xl text-gold-gradient">{BRAND.tagline}</h2>
              <p className="font-cormorant text-xl text-[#f5ecd9]/75 mt-3">{BRAND.promo}.</p>
              <div className="flex flex-col sm:flex-row gap-3 mt-6">
                <Link to="/shop" className="btn-gold inline-flex items-center justify-center gap-2 rounded-full px-8 py-3.5 text-sm font-semibold text-[#0a0708] bg-gradient-to-r from-[#d4af37] via-[#f0d582] to-[#d4af37]">Shop Now <ArrowRight className="h-4 w-4" /></Link>
                <Link to="/book" className="inline-flex items-center justify-center gap-2 rounded-full px-8 py-3.5 text-sm font-medium text-[#f0d582] border border-[#d4af37]/40 hover:bg-[#d4af37]/10 transition-colors">Book A Healing</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
